<div class="ds-edit-page">

  <!-- Header -->
  <div class="ds-header">
    <button mat-icon-button (click)="cancel()" matTooltip="Volver" class="ds-back-btn">
      <mat-icon>arrow_back</mat-icon>
    </button>
    <mat-icon class="ds-header-icon">event</mat-icon>
    <div class="ds-header-text">
      <h2 class="ds-title">{{ pageTitle }}</h2>
      <p class="ds-subtitle">{{ ((state$ | async)?.date | date:'longDate') ?? '' }}</p>
    </div>
  </div>

  <!-- Loading State -->
  <mat-card class="ds-card" *ngIf="isLoadingPermissions || (state$ | async)?.isLoading">
    <mat-card-content class="loading-state">
      <mat-spinner></mat-spinner>
      <p>Cargando datos del servicio...</p>
    </mat-card-content>
  </mat-card>

  <!-- Form Content -->
  <mat-card class="ds-card" *ngIf="!isLoadingPermissions && !((state$ | async)?.isLoading) && serviceForm">
    <mat-card-content>
      <form [formGroup]="serviceForm">
        <app-divine-service-form [serviceForm]="serviceForm" [serviceTypes]="(serviceTypes$ | async) || []"
          [isLoadingServiceTypes]="false" [optionalFieldsVisibility]="(visibility$ | async)"
          [unitSource]="unitSource"
          (visibilityChange)="onFieldVisibilityChange($event)">
        </app-divine-service-form>
      </form>
    </mat-card-content>
  </mat-card>

  <!-- Footer Actions -->
  <div class="ds-footer">
    <button mat-button type="button" (click)="cancel()" [disabled]="(state$ | async)?.isSaving">
      <mat-icon>close</mat-icon>
      Cancelar
    </button>
    <button mat-raised-button color="primary" type="button" (click)="save()"
      [disabled]="(state$ | async)?.isSaving">
      <mat-spinner *ngIf="(state$ | async)?.isSaving" diameter="20" class="button-spinner"></mat-spinner>
      <mat-icon *ngIf="!((state$ | async)?.isSaving)">save</mat-icon>
      {{ (state$ | async)?.isSaving ? 'Guardando...' : 'Guardar' }}
    </button>
  </div>

</div>
